import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { TaskListPage, ModalAddTaskPage } from './taskList';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    TaskListPage,
    ModalAddTaskPage,
  ],
  imports: [
    IonicPageModule.forChild(TaskListPage),
    CalendarModule,
  ],

  entryComponents: [
    ModalAddTaskPage,
  ],
  providers: [
    RestProvider,
  ]
})
export class TaskListPageModule {}



// WEBPACK FOOTER //
// ./src/pages/taskList/taskList.module.ts